import keycloakService from "../keycloakService";

export const ROLE = {
    Admin:'admin',
    User:'user',
    SuperAdmin:'super_admin'
}
export const getValidToken  = async () =>{
    const isLoggedIn = keycloakService.isLoggedIn();
    if(isLoggedIn){
        await keycloakService.updateToken();
        const token = keycloakService.getToken();
        return token;
    }
    return keycloakService.login();
}
export const authHeader = (token) =>{
    const headers={
        headers:{
            'Content-Type': 'application/json'
        }
    };
    if(token){
        headers.headers.Authorization = `Bearer ${token}`;
    }
    return headers;
}
export const API_URL = process.env.REACT_APP_API_URL;
export const KEYCLOAK_SERVER_BASE_URL = process.env.REACT_APP_KEYCLOAK_SERVER_BASE_URL;
export const KEYCLOAK_CLIENT_ID = process.env.REACT_APP_KEYCLOAK_SERVER_CLIENT_ID;
export const KEYCLAOK_REALM = process.env.REACT_APP_KEYCLOAK_SERVER_REALM;
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
//'AIzaSyCf_mfmBLqSooeSI9WwkS_ND7OPgRJj03w'